/**
 * External dependencies
 */
import {  useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

/**
 * Internal dependencies
 */
import { getBuilderReportId } from 'state/ui/report-builder/selectors';
import { getEditedReport } from 'state/reports/selectors';
import { editReport, saveReport, deleteReport } from 'state/reports/actions';

const useReportBuilder = () => {
	const [isSaving, setSaving] = useState(false);
	const [error, setError] = useState();
	const [isDeleting, setDeleting] = useState(false);

	const dispatch = useDispatch();
	const reportId = useSelector((state) => getBuilderReportId(state));
	const report = useSelector((state) => getEditedReport(state, reportId));

	const handleEditReport = (edits) => {
		return dispatch(editReport(reportId, edits));
	};

	const handleDeleteReport = () => {
		setDeleting(true);
		return dispatch(deleteReport(reportId))
			.catch((e) => setError(e.message))
			.finally(() => setDeleting(false));
	};

	const handleSaveReport = () => {
		setSaving(true);

		return dispatch(saveReport(reportId, report))
			.catch((e) => {setError(e.message);console.log(e.message)})
			.finally(() => setSaving(false));
	};

	return {
		report,
		reportId,
		editReport: handleEditReport,
		deleteReport: handleDeleteReport,
		saveReport: handleSaveReport,
		isDeleting,
		isSaving,
		error,
	};
};

export default useReportBuilder;
